import { useState, useCallback } from "react";
import * as Constants from "../components/Constants.js";

const useSearchURL = () => {
  const [isBuscando, setBuscando] = useState(false);
  const [erroresSearch, setErrorSearch] = useState(null);

  const searchData = useCallback(async (path, datos, usarDatos) => {
    setBuscando(true);
    setErrorSearch(null);

    try {
      const response = await fetch(Constants.URLBASE + "/" + path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(datos),
        redirect: "follow",
        credentials: "include",
      });

      if (response.status === 401) {
        document.location.href = "/nosession";
      } else if (response.redirected) {
        document.location = response.url;
      } else if (!response.ok) {
        throw new Error(response.status + " - " + response.error);
      }

      if (response.status === 204) {
        usarDatos([]);
      } else {
        const env = await response.json();
        if (env && (env.ok === true || env.ok === false || 'data' in env || 'errors' in env || 'errores' in env)) {
          if (env.ok) {
            usarDatos(env.data ?? []);
          } else {
            setErrorSearch(env.errors ?? env.errores ?? ["Error en la búsqueda"]);
            usarDatos([]);
          }
        } else {
          usarDatos(env);
        }
      }

    } catch (err) {
      setErrorSearch(["Error en la búsqueda: " + err.message]);
      usarDatos([]);
    }
    setBuscando(false);
  }, []);

  const resetErroresSearch = () => {
    setErrorSearch(null);
  }

  return {isBuscando, erroresSearch, searchData, resetErroresSearch};
};

export default useSearchURL;
